/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/solid";

export default function SimpleNotification(props) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setShow(true);
        }, 1);
    }, []);

    useEffect(() => {
        if (!props.timeout) {
            return;
        }
        const timeout = setTimeout(() => {
            setShow(false);
        }, props.timeout);
        return () => clearTimeout(timeout);
    }, [props.timeout]);

    return (
        <Transition
            show={show}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
        >
            <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                <div className="p-4">
                    <div className="flex items-center">
                        <div className="flex w-0 flex-1 justify-between">
                            <p className="w-0 flex-1 text-sm font-medium text-gray-900">
                                {props.index} {props.message}
                            </p>
                            {props.buttonText && (
                                <button
                                    type="button"
                                    onClick={props.onClick}
                                    className="focus:outline-none ml-3 flex-shrink-0 rounded-md bg-white text-sm font-medium text-green-600 hover:text-green-500 focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                >
                                    {props.buttonText}
                                </button>
                            )}
                        </div>
                        <div className="ml-4 flex flex-shrink-0">
                            <button
                                className="focus:outline-none inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                onClick={() => {
                                    setShow(false);
                                    props.onClose();
                                }}
                            >
                                <span className="sr-only">Close</span>
                                <XIcon className="h-5 w-5" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    );
}
